import { createService } from "@/Services/BaseService";

const RoiProcessGroupService = createService("api/ProcessRoiGroup");

export function getProcessGroups(databaseDisplayName) {
  return RoiProcessGroupService.get(`?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`);
}

export function createProcessGroup(databaseDisplayName, name) {
  return RoiProcessGroupService.post(
    `?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { name }
  );
}

export function renameProcessGroup(databaseDisplayName, id, name) {
  return RoiProcessGroupService.put(
    `/${id}?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { name }
  );
}

export function deleteProcessGroup(databaseDisplayName, id) {
  return RoiProcessGroupService.delete(
    `/${id}?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`
  );
}

export function setProcessMembership(databaseDisplayName, processRoiId, groupId) {
  return RoiProcessGroupService.put(
    `/membership?databaseDisplayName=${encodeURIComponent(databaseDisplayName)}`,
    { processRoiId, groupId }
  );
}
